import {
  IntentInstallOptions,
  PlatformApiMethods,
} from '@wix/editor-platform-host-integration-apis';
import { IntentInstallStore } from '../IntentInstallStore';
import { ProgressBarManagerDefault } from './ProgressBarManagerDefault';
import { ProgressBarManagerDisabled } from './ProgressBarManagerDisabled';
import { ProgressBarManager } from './types';

export const createProgressBarManager = (
  platformApiMethods: PlatformApiMethods,
  intentStore: IntentInstallStore,
  options: IntentInstallOptions,
): ProgressBarManager => {
  if (options.disableProgressBar) {
    return new ProgressBarManagerDisabled();
  }

  return new ProgressBarManagerDefault(platformApiMethods, intentStore);
};
